"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var decorated_number_1 = __importDefault(require("../decorated-number"));
var detect_country_1 = __importDefault(require("../detect-country"));
var number_part_1 = require("../number-part");
var decorator = {
    decorate: function (phoneNumber, extensionConfig) {
        if (extensionConfig === void 0) { extensionConfig = { decoratedDelimiter: " ext. ", delimiter: "x" }; }
        var country = detect_country_1.default(phoneNumber);
        var decoratedNumber = new decorated_number_1.default([
            number_part_1.internationalDecorativePart("+"),
        ]);
        if (country) {
            for (var _i = 0, _a = country.dialingCode; _i < _a.length; _i++) {
                var digit = _a[_i];
                decoratedNumber.parts.push(number_part_1.countryCodePart(digit));
            }
            decoratedNumber.parts.push(number_part_1.internationalDecorativePart(" "));
            phoneNumber = phoneNumber.substring(country.dialingCode.length);
        }
        var isExtension = false;
        for (var _b = 0, phoneNumber_1 = phoneNumber; _b < phoneNumber_1.length; _b++) {
            var digit = phoneNumber_1[_b];
            if (digit === extensionConfig.delimiter) {
                decoratedNumber.parts.push(number_part_1.extensionDecorativePart(extensionConfig));
                isExtension = true;
            }
            else if (isExtension) {
                decoratedNumber.parts.push(number_part_1.extensionPart(digit));
            }
            else {
                decoratedNumber.parts.push(number_part_1.numberPart(digit));
            }
        }
        return decoratedNumber;
    },
};
exports.default = decorator;
//# sourceMappingURL=unknown.js.map